export const CountStudySessions = {
	name: "CountStudySessions",
	description: "Count sessions that match a filter.",
	parameters: {
		// progress: {
		// 	type:"number",
		// 	drawer:{
		// 		type:"range",
		// 		max:100,
		// 		min:0,
		// 		step:1
		// 	},
		// 	default:0
		// },
		filter:{
			type:"object",
			drawer:{
				type:"session-filter"
			},
			default:{}
		}
	},
	output:{
		n:{
			type:"number"
		}
	},
};